export const ERROR_NOT_FOUND = 'ERROR_NOT_FOUND';
export const ERROR_USER_ALREADY_SUBSCRIBED = 'ERROR_USER_ALREADY_SUBSCRIBED';
